<template>
  <div>
    <ed-form :model="formData">
      <ed-input-select
        class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12"
        label="Empresa"
        v-model="formData.id_emp"
        :items="lstEmpresa"
        :loading="loadingEmpresa"
        @search="getEmpresa"
        clearable
        remote
      />

      <ed-input-select
        class="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6"
        label="Layout"
        v-model="formData.layout"
        :items="lstLayout"
        itemValue="codigo"
        clearable
      />

      <ed-input-date
        class="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6"
        label="Periodo de Apuramento"
        v-model="formData.periodo"
        format="MM/yyyy"
        type="month"
      />

      <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 text-center mt-5">
        <ed-button
          type="success"
          label="Consultar Informações no eSocial"
          icon="fa fa-search"
          :loading="loading"
          :disabled="!formData.id_emp || !formData.layout || !formData.periodo ? true : false"
          @click="consultar"
        />
      </div>
    </ed-form>

    <div class="consulta-esocial-erro" v-if="erro">
      <i class="fa fa-exclamation-triangle"></i>
      <span>{{ erro }}</span>
    </div>

    <div class="col-12 mt-5" v-if="formData.strXml">
      <div class="consulta-esocial-contexto">
        <div class="consulta-esocial-contexto__item">
          <span class="consulta-esocial-contexto__label">Layout</span>
          <span class="consulta-esocial-contexto__value">{{ consultadoEm.layout }}</span>
        </div>
        <div class="consulta-esocial-contexto__item">
          <span class="consulta-esocial-contexto__label">Período</span>
          <span class="consulta-esocial-contexto__value">{{ consultadoEm.periodo }}</span>
        </div>
        <div class="consulta-esocial-contexto__item">
          <span class="consulta-esocial-contexto__label">Empresa</span>
          <span class="consulta-esocial-contexto__value">{{ consultadoEm.empresa }}</span>
        </div>
        <div class="consulta-esocial-contexto__item">
          <span class="consulta-esocial-contexto__label">Consultado em</span>
          <span class="consulta-esocial-contexto__value">{{ consultadoEm.data }}</span>
        </div>
      </div>

      <h4><b>Informações no eSocial</b></h4>

      <XmlViewer :xml="formData.strXml" />
    </div>
  </div>
</template>

<script>
import XmlViewer from "vue-xml-viewer";
import { EdForm, EdButton, EdInputSelect, EdInputText, EdInputDate } from "template";

export default {
  name: "esocial-lotes-reenviar-email",
  mixins: [],
  components: {
    XmlViewer,
    EdForm,
    EdButton,
    EdInputSelect,
    EdInputText,
    EdInputDate,
  },

  props: {
    lstEmpresa: {
      type: [Array],
      default: [],
    },
    loadingEmpresa: {
      type: Boolean,
      default: false,
    },
    loadingFuncionario: {
      type: Boolean,
      default: false,
    },
  },
  inject: ["getEmpresa", "getLayout"],
  watch: {
    lstEmpresa: {
      handler: function (newVal) {},
      deep: true,
    },
    loadingEmpresa() {},
    loadingFuncionario() {},
  },

  data() {
    return {
      formData: {
        id_emp: null,
        id_fun: null,
        layout: null,
        busca: null,
        strXml: null,
      },
      loading: false,
      erro: null,
      consultadoEm: {},
      lstLayout: [
        { codigo: "S-1000", nome: "S-1000" },
        { codigo: "S-1005", nome: "S-1005" },
        { codigo: "S-1010", nome: "S-1010" },
        { codigo: "S-1020", nome: "S-1020" },
        { codigo: "S-1030", nome: "S-1030" },
        { codigo: "S-1035", nome: "S-1035" },
        { codigo: "S-1040", nome: "S-1040" },
        { codigo: "S-1050", nome: "S-1050" },
        { codigo: "S-1060", nome: "S-1060" },
        { codigo: "S-1065", nome: "S-1065" },
        { codigo: "S-1070", nome: "S-1070" },
        { codigo: "S-1080", nome: "S-1080" },
        { codigo: "S-1200", nome: "S-1200" },
        { codigo: "S-1202", nome: "S-1202" },
        { codigo: "S-1207", nome: "S-1207" },
        { codigo: "S-1210", nome: "S-1210" },
        { codigo: "S-1250", nome: "S-1250" },
        { codigo: "S-1260", nome: "S-1260" },
        { codigo: "S-1270", nome: "S-1270" },
        { codigo: "S-1280", nome: "S-1280" },
        { codigo: "S-1295", nome: "S-1295" },
        { codigo: "S-1298", nome: "S-1298" },
        { codigo: "S-1299", nome: "S-1299" },
        { codigo: "S-1300", nome: "S-1300" },
        { codigo: "S-2190", nome: "S-2190" },
        { codigo: "S-2200", nome: "S-2200" },
        { codigo: "S-2205", nome: "S-2205" },
        { codigo: "S-2206", nome: "S-2206" },
        { codigo: "S-2210", nome: "S-2210" },
        { codigo: "S-2220", nome: "S-2220" },
        { codigo: "S-2230", nome: "S-2230" },
        { codigo: "S-2240", nome: "S-2240" },
        { codigo: "S-2241", nome: "S-2241" },
        { codigo: "S-2245", nome: "S-2245" },
        { codigo: "S-2250", nome: "S-2250" },
        { codigo: "S-2298", nome: "S-2298" },
        { codigo: "S-2299", nome: "S-2299" },
        { codigo: "S-2300", nome: "S-2300" },
        { codigo: "S-2306", nome: "S-2306" },
        { codigo: "S-2399", nome: "S-2399" },
        { codigo: "S-2400", nome: "S-2400" },
        { codigo: "S-3000", nome: "S-3000" },
        { codigo: "S-5001", nome: "S-5001" },
        { codigo: "S-5002", nome: "S-5002" },
        { codigo: "S-5011", nome: "S-5011" },
        { codigo: "S-5012", nome: "S-5012" },
      ],
    };
  },

  created() {},

  mounted() {},

  methods: {
    consultar() {
      this.loading = true;
      this.erro = null;
      this.formData.strXml = null;

      this.$root.$request
        .post("esocial/lotes/consultar/" + this.formData.id_emp + "/evento-empresa", this.formData)
        .then((result) => {
          this.loading = false;

          if (result.status == 200) {
            this.formData.strXml = result.data;
            this.consultadoEm = {
              layout: this.formData.layout,
              periodo: this.formData.periodo,
              empresa: this.empresaSelecionada(),
              data: this.toDate(new Date()),
            };
          } else {
            this.erro = result.msg || "Não foi possível consultar os eventos do empregador no eSocial.";
          }
        });
    },

    empresaSelecionada() {
      var empresa = (this.lstEmpresa || []).find((e) => e.id == this.formData.id_emp);
      return empresa ? empresa.nome : this.formData.id_emp;
    },

    toDate(date) {
      return new Date(date).toLocaleString("pt-BR");
    },
  },
};
</script>

<style lang="scss" scoped>
.consulta-esocial-erro {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 16px;
  padding: 12px 16px;
  border-radius: 8px;
  background: rgba(192, 57, 43, 0.08);
  color: #c0392b;
  font-size: 12px;

  i {
    font-size: 14px;
  }
}

.consulta-esocial-contexto {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  margin-bottom: 14px;
  padding: 12px 16px;
  border-radius: 8px;
  background: #f7f9fb;
  border: 1px solid #eef0f2;
}

.consulta-esocial-contexto__item {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.consulta-esocial-contexto__label {
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  color: #9aa0a8;
}

.consulta-esocial-contexto__value {
  font-size: 12px;
  color: #1f2329;
  font-weight: 600;
}
</style>



// WEBPACK FOOTER //
// consulta-evento-empresa.vue?fc10e63a